var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarHalfFilled = function SvgStarHalfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 1L9.94683 5.68063L15 6.08573L11.15 9.38363L12.3262 14.3146L8.00005 11.6722V7.62413V1Z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99991 1L6.05313 5.68063L1 6.08573L4.84995 9.38363L3.67373 14.3146L7.99991 11.6722V1Z",
    fill: "#FDC400"
  })));
};
export default SvgStarHalfFilled;